const API_BASE_URL = '/api';

class AuthService {
  async getCaptchaConfig() {
    const response = await fetch(`${API_BASE_URL}/auth/captcha-config`);
    if (!response.ok) return { enabled: false };
    return response.json();
  }

  async login(username, password, orgSlug = null, captchaToken = null) {
    const body = { username, password };
    if (orgSlug) body.orgSlug = orgSlug;
    if (captchaToken) body.captchaToken = captchaToken;
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      let msg = 'Invalid credentials';
      try {
        const err = await response.json();
        if (err.error) msg = err.error;
      } catch (_) { /* ignore parse errors */ }
      throw new Error(msg);
    }

    return response.json();
  }

  async validateToken(token) {
    const response = await fetch(`${API_BASE_URL}/auth/validate`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Invalid token');
    }

    return response.json();
  }

  async resolveOrg(slug) {
    const response = await fetch(`${API_BASE_URL}/auth/org/${encodeURIComponent(slug)}`);
    if (!response.ok) throw new Error('Organization not found');
    return response.json();
  }

  async switchOrg(orgSlug) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/auth/switch-org`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orgSlug }),
    });

    if (!response.ok) throw new Error('Failed to switch organization');
    return response.json();
  }

  // ── Operator 2FA (authenticator app / TOTP) ──
  async mfaEnroll(pendingToken) {
    const res = await fetch(`${API_BASE_URL}/auth/mfa/enroll`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pendingToken }),
    });
    if (!res.ok) throw new Error('Could not start authenticator setup');
    return res.json(); // { secret, otpauthUri }
  }

  async mfaVerifyEnroll(pendingToken, code) {
    return this._mfaComplete('/auth/mfa/verify-enroll', pendingToken, code);
  }

  async mfaVerify(pendingToken, code) {
    return this._mfaComplete('/auth/mfa/verify', pendingToken, code);
  }

  async _mfaComplete(path, pendingToken, code) {
    const res = await fetch(`${API_BASE_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pendingToken, code }),
    });
    if (!res.ok) {
      let msg = 'Invalid code';
      try { const e = await res.json(); if (e.error) msg = e.error; } catch (_) { /* ignore */ }
      throw new Error(msg);
    }
    return res.json(); // AuthResponse with token
  }

  getAuthHeader() {
    const token = localStorage.getItem('authToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }
}

const authService = new AuthService();
export default authService;